import Image from "next/image";

export default function getBoxImage(packingType, length, width, height) {
  [length, width, height] =
    length && width && height ? [length, width, height] : [1, 1, 1];
  //1. Shrink numbers by dividing all numbers by the smallest
  const minNum = Math.min(length, width, height);
  length = length / minNum;
  width = width / minNum;
  height = height / minNum;

  //2. Bring up values to the nearest whole number
  length = Math.min(Math.round(length), 3);
  width = Math.min(Math.round(width), 3);
  height = Math.min(Math.round(height), 3);

  //3. Aspect Ratio comparision
  let boxImage = "";
  if ((length === 2 && width === 3) || (length === 3 && width === 2)) {
    boxImage = `3x2x${height}.png`;
  } else if ((length === 1 && width === 3) || (length === 3 && width === 1)) {
    boxImage = `3x1x${height}.png`;
  } else if ((length === 1 && width === 2) || (length === 2 && width === 1)) {
    boxImage = `2x1x${height}.png`;
  } else if (length === width && width === height) {
    boxImage = `3x3x3.png`;
  } else {
    boxImage = `${+length}x${+width}x${+height}.png`;
  }

  const folder = packingType === "No" ? "No" : "Hands";
  return length && width && height ? (
    <Image
      src={`/boxes/${folder}/${boxImage}`}
      alt={`${length}:${width}:${height} box`}
      width={200}
      height={200}
    />
  ) : null;
}
